/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { ReactNode } from "react";
import { Box, Divider, Paper, Skeleton, SxProps, Theme, Typography } from "@mui/material";
import { TypographyProps } from "@mui/material/Typography";
import { mergeSx } from "@/src/utils/mergeSx";
import contentBoxStyle from "./contentBoxStyle";

export type ContentBoxProps = {
  headline?: ReactNode;
  children: ReactNode;
  headlineVariant?: TypographyProps["variant"];
  showDivider?: boolean;
  sx?: SxProps<Theme>;
  icon?: React.ComponentType<{ sx?: SxProps<Theme> }>;
  loading?: boolean;
};

export default function ContentBox({ headline, children, headlineVariant = "h7", showDivider = false, sx, icon: Icon, loading = false }: ContentBoxProps) {
  return (
    <Paper elevation={4} sx={mergeSx(contentBoxStyle.paper, sx)}>
      {loading ? (
        <Skeleton width="40%" height="2rem" sx={contentBoxStyle.heading} />
      ) : (
        !!headline && (
          <Box sx={mergeSx(contentBoxStyle.heading, Icon && contentBoxStyle.headingWithIcon, showDivider && { marginBottom: 0 })}>
            {Icon && (
              <Box sx={contentBoxStyle.iconContainer}>
                <Icon sx={contentBoxStyle.icon} />
              </Box>
            )}
            <Typography variant={headlineVariant} component="h2">
              {headline}
            </Typography>
          </Box>
        )
      )}

      {showDivider && <Divider sx={contentBoxStyle.divider} />}

      <Box>{children}</Box>
    </Paper>
  );
}
